<template>
  <b-modal
    v-model="isVisible"
    centered
    hide-header
    hide-footer
    no-close-on-backdrop
    modal-class="app-long-loading-modal"
  >
    <div class="app-long-loading-modal-content">
      <img src="/images/flying-drone.gif" alt="" class="app-long-loading-modal-drone" />
      <p class="app-long-loading-modal-text">{{ $t("long-loading-time-hint") }}</p>
      <b-spinner small />
    </div>
  </b-modal>
</template>

<script lang="ts">
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  name: "app-long-loading-modal",
})
export default class AppLongLoadingModal extends Vue {
  @Prop({ default: false }) visible!: boolean;

  get isVisible(): boolean {
    return this.visible;
  }

  set isVisible(visible: boolean) {
    this.$emit("update:visible", visible);
  }
}
</script>

<style lang="scss">
.app-long-loading-modal {
  &-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 1rem 0;
    text-align: center;
  }

  &-drone {
    width: 240px;
    max-width: 100%;
  }

  &-text {
    margin: 1rem 0;
    font-size: 1.1rem;
  }
}
</style>
